import { useCallback } from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import { isNilOrEmpty } from 'ramda-extension';
import { useDispatch, useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import CardRange from 'components/atoms/GefMui/CardRange';
import OutputTextField from 'components/atoms/GefMui/OutputTextField';
import { getContactOrderById } from 'features/views/campaignDashboards/order/selectors';
import { changeContactOrder } from 'features/views/campaignDashboards/order/slice';
import { number } from 'utils';

const ContactOrder = ({ contactOrderId, tabIndex, disabled }) => {
	const dispatch = useDispatch();

	const contactOrder = useSelector((state) => getContactOrderById(state, contactOrderId));

	const handleChangeValue = useCallback(
		(value) => {
			dispatch(
				changeContactOrder({
					id: contactOrderId,
					orderedLeads: value,
				}),
			);
		},
		[dispatch, contactOrderId],
	);

	return (
		<Grid size={12}>
			<Grid container spacing={2}>
				<Grid size={1} />
				<Grid size={2}>
					<OutputTextField
						size="small"
						id="zipCode"
						label={getLabelMessage('order:zipCode')}
						fullWidth
						value={contactOrder.zipCode}
						slotProps={{
							inputLabel: {
								shrink: !!contactOrder.zipCode,
							},
						}}
						variant="standard"
						disabled
					/>
				</Grid>
				<Grid size={4}>
					<OutputTextField
						size="small"
						id="avilableContacts"
						label={getLabelMessage('order:availableContacts')}
						fullWidth
						value={`${number(contactOrder.offeredLeads)} ${getLabelMessage('order:pieces')}`}
						slotProps={{
							inputLabel: {
								shrink: !isNilOrEmpty(contactOrder.offeredLeads),
							},
						}}
						variant="standard"
						disabled
					/>
				</Grid>
				<Grid size={4}>
					<CardRange
						type={'info'}
						disabled={disabled}
						tabIndex={tabIndex}
						text={getLabelMessage('order:yourOrder')}
						value={contactOrder.orderedLeads}
						maxValue={contactOrder.offeredLeads}
						unit={getLabelMessage('order:pieces')}
						onChange={handleChangeValue}
					/>
				</Grid>
				<Grid size={1} />
			</Grid>
		</Grid>
	);
};

ContactOrder.propTypes = {
	contactOrder: PropTypes.object,
	contactOrderId: PropTypes.string,
	disabled: PropTypes.bool,
	tabIndex: PropTypes.number,
};

export default ContactOrder;
